// src/context/AuthContext.jsx
import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { storage } from "../services/storage";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [authData, setAuthData] = useState(null);
  const [authInitialized, setAuthInitialized] = useState(false);

  // Hydrate from localStorage on mount
  useEffect(() => {
    const stored = storage.getAuthData();
    if (stored) setAuthData(stored);
    setAuthInitialized(true);
  }, []);

  // Logout clears storage + state.
  // Navigation to /login is handled automatically by the RequireRole / HomeRedirect
  // guards in AuthSystem when they detect authData === null.
  const logout = useCallback(() => {
    storage.clear();
    setAuthData(null);
  }, []);

  return (
    <AuthContext.Provider value={{ authData, setAuthData, authInitialized, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
  return ctx;
}
